
import { Market } from "./Market";
import { Panel } from "./wrappers/Panel";

export const MarketBar = () => {
  return (<Panel>
    <Market />
  </Panel>);
};